"use client";
import { Role } from "../role/role.js";
import { useDisclosureContent } from "../disclosure/disclosure-content.js";
import { useDisclosureStore } from "../disclosure/disclosure-store.js";
import { markAncestor } from "./utils/tree-cleanup.js";
import { useMergeRefs, useSafeLayoutEffect } from "@ariakit/react-utils";
import { isValidElement, useRef } from "react";
import { jsx } from "react/jsx-runtime";
import { useStoreState } from "@ariakit/react-store";
//#region src/dialog/dialog-backdrop.tsx
function DialogBackdrop({ store, backdrop, backdropRef, alwaysVisible, hidden }) {
	const ref = useRef(null);
	const disclosure = useDisclosureStore({ disclosure: store });
	const contentElement = useStoreState(store, "contentElement");
	useSafeLayoutEffect(() => {
		const backdrop = ref.current;
		const dialog = contentElement;
		if (!backdrop) return;
		if (!dialog) return;
		backdrop.style.zIndex = getComputedStyle(dialog).zIndex;
	}, [contentElement]);
	useSafeLayoutEffect(() => {
		const id = contentElement?.id;
		if (!id) return;
		const backdrop = ref.current;
		if (!backdrop) return;
		return markAncestor(backdrop, id);
	}, [contentElement]);
	const props = useDisclosureContent({
		ref: useMergeRefs(ref, backdropRef),
		store: disclosure,
		role: "presentation",
		"data-backdrop": contentElement?.id || "",
		alwaysVisible,
		hidden: hidden != null ? hidden : void 0,
		style: {
			position: "fixed",
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	});
	if (!backdrop) return null;
	if (isValidElement(backdrop)) return /* @__PURE__ */ jsx(Role, {
		...props,
		render: backdrop
	});
	const Component = typeof backdrop !== "boolean" ? backdrop : "div";
	return /* @__PURE__ */ jsx(Role, {
		...props,
		render: /* @__PURE__ */ jsx(Component, {})
	});
}
//#endregion
export { DialogBackdrop };

//# sourceMappingURL=dialog-backdrop.js.map